import { render } from "./ProfileCard.vue?vue&type=template&id=95a76e00&scoped=true"
import script from "./ProfileCard.vue?vue&type=script&lang=js"
export * from "./ProfileCard.vue?vue&type=script&lang=js"

import "./ProfileCard.vue?vue&type=style&index=0&id=95a76e00&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-95a76e00"

export default script